import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import km from './locales/km.json';

const messages = {
  en,
  km,
};

const i18n = createI18n({
  legacy: false, // Use Composition API
  locale: localStorage.getItem('lang') || 'en',
  fallbackLocale: 'en',
  messages,
});

export default i18n;
